import * as React from 'react';
import { connect } from 'react-redux';

import { ButtonCheckbox } from '../../../../common/components/button_checkbox/index';
import { IAppState, Dispatch } from '../../../../common/state';
import { ESuburbanUtility, IJsonQuery } from '../../../../json_query';
import { changeSuburbanUtility } from '../../../state/advanced/suburban_utilities';
import { InlineParam, Row } from '../markup';

export interface ISuburbanUtilitiesProps {
  utilities: ESuburbanUtility[];
  onSuburbanUtilitiesChanged(param: ESuburbanUtility, value: boolean): void;
}

interface ISuburbanUtility {
  title: string;
  type: ESuburbanUtility;
}

const suburbanUtilitiesProps: ISuburbanUtility[] = [
  { title: 'Электричество', type: ESuburbanUtility.Electricity },
  { title: 'Газ', type: ESuburbanUtility.Gas },
  { title: 'Канализация', type: ESuburbanUtility.Drainage },
  { title: 'Водоснабжение', type: ESuburbanUtility.Water },
];

export const SuburbanUtilities: React.StatelessComponent<ISuburbanUtilitiesProps> = props => {
  return (
    <Row title="Наличие на участке">
      {suburbanUtilitiesProps.map(utility => (
        <InlineParam key={utility.type}>
          <ButtonCheckbox
            onValueChange={value => props.onSuburbanUtilitiesChanged(utility.type, value)}
            value={props.utilities.indexOf(utility.type) !== -1}
          >
            {utility.title}
          </ButtonCheckbox>
        </InlineParam>
      ))}
    </Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    utilities: utilitiesFromJsonQuery(state.filters.jsonQuery),
  }),
  (dispatch: Dispatch) => ({
    onSuburbanUtilitiesChanged: (param: ESuburbanUtility, value: boolean) => {
      dispatch(changeSuburbanUtility(param, value));
    },
  }),
)(SuburbanUtilities);

function utilitiesFromJsonQuery(jsonQuery: IJsonQuery): ESuburbanUtility[] {
  return Object.keys(ESuburbanUtility).reduce((previousValue, currentValue) => {
    // tslint:disable-next-line:no-any
    const utility = (ESuburbanUtility as any)[currentValue] as ESuburbanUtility;
    if (jsonQuery[utility] !== undefined) {
      previousValue.push(utility);
    }

    return previousValue;
  }, [] as ESuburbanUtility[]);
}
